module.exports = __webpack_public_path__ + "img/buttonC.1a251fe7.png";